import type { EnrichmentJobStatus } from '../types';

type JobStatus = EnrichmentJobStatus['status'];
export type SettledEnrichmentJobStatus = Extract<JobStatus, 'partial' | 'cancelled' | 'completed' | 'failed'>;

const ACTIVE_STATUSES = new Set<JobStatus>(['queued', 'running', 'waiting']);
const SETTLED_STATUSES = new Set<JobStatus>(['partial', 'cancelled', 'completed', 'failed']);

export function isEnrichmentJobActive(status: JobStatus): boolean {
    return ACTIVE_STATUSES.has(status);
}

export function isEnrichmentJobSettled(status: JobStatus): status is SettledEnrichmentJobStatus {
    return SETTLED_STATUSES.has(status);
}
